import { call, put, takeEvery } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import supplierService, {
  CreateSupplierData,
} from "../../services/supplierService";
import {
  getSuppliersStart,
  getSuppliersSuccess,
  getSuppliersFailure,
  getSupplierStart,
  getSupplierSuccess,
  getSupplierFailure,
  createSupplierStart,
  createSupplierSuccess,
  createSupplierFailure,
  updateSupplierStart,
  updateSupplierSuccess,
  updateSupplierFailure,
  deleteSupplierStart,
  deleteSupplierSuccess,
  deleteSupplierFailure,
  getSupplierStatsStart,
  getSupplierStatsSuccess,
  getSupplierStatsFailure,
} from "../slices/supplierSlice";

// Get suppliers saga
function* getSuppliersSaga(
  action: PayloadAction<{
    page?: number;
    limit?: number;
    search?: string;
    isActive?: boolean;
  }>
): Generator<any, void, any> {
  try {
    const response: any = yield call(
      supplierService.getSuppliers,
      action.payload
    );
    yield put(
      getSuppliersSuccess({
        suppliers: response.data,
        pagination: response.pagination,
      })
    );
  } catch (error: any) {
    yield put(
      getSuppliersFailure(
        error.response?.data?.message || "Failed to get suppliers"
      )
    );
  }
}

// Get single supplier saga
function* getSupplierSaga(
  action: PayloadAction<string>
): Generator<any, void, any> {
  try {
    const response: any = yield call(
      supplierService.getSupplier,
      action.payload
    );
    yield put(getSupplierSuccess(response.data));
  } catch (error: any) {
    yield put(
      getSupplierFailure(
        error.response?.data?.message || "Failed to get supplier"
      )
    );
  }
}

// Create supplier saga
function* createSupplierSaga(
  action: PayloadAction<CreateSupplierData>
): Generator<any, void, any> {
  try {
    const response: any = yield call(
      supplierService.createSupplier,
      action.payload
    );
    yield put(createSupplierSuccess(response.data));
  } catch (error: any) {
    yield put(
      createSupplierFailure(
        error.response?.data?.message || "Failed to create supplier"
      )
    );
  }
}

// Update supplier saga
function* updateSupplierSaga(
  action: PayloadAction<{
    id: string;
    data: Partial<CreateSupplierData>;
  }>
): Generator<any, void, any> {
  try {
    const response: any = yield call(
      supplierService.updateSupplier,
      action.payload.id,
      action.payload.data
    );
    yield put(updateSupplierSuccess(response.data));
  } catch (error: any) {
    yield put(
      updateSupplierFailure(
        error.response?.data?.message || "Failed to update supplier"
      )
    );
  }
}

// Delete supplier saga
function* deleteSupplierSaga(
  action: PayloadAction<string>
): Generator<any, void, any> {
  try {
    yield call(supplierService.deleteSupplier, action.payload);
    yield put(deleteSupplierSuccess(action.payload));
  } catch (error: any) {
    yield put(
      deleteSupplierFailure(
        error.response?.data?.message || "Failed to delete supplier"
      )
    );
  }
}

// Get supplier stats saga
function* getSupplierStatsSaga(): Generator<any, void, any> {
  try {
    const response: any = yield call(supplierService.getSupplierStats);
    yield put(getSupplierStatsSuccess(response.data));
  } catch (error: any) {
    yield put(
      getSupplierStatsFailure(
        error.response?.data?.message || "Failed to get supplier stats"
      )
    );
  }
}

// Watchers
export function* watchGetSuppliersSaga() {
  yield takeEvery(getSuppliersStart.type, getSuppliersSaga);
}

export function* watchGetSupplierSaga() {
  yield takeEvery(getSupplierStart.type, getSupplierSaga);
}

export function* watchCreateSupplierSaga() {
  yield takeEvery(createSupplierStart.type, createSupplierSaga);
}

export function* watchUpdateSupplierSaga() {
  yield takeEvery(updateSupplierStart.type, updateSupplierSaga);
}

export function* watchDeleteSupplierSaga() {
  yield takeEvery(deleteSupplierStart.type, deleteSupplierSaga);
}

export function* watchGetSupplierStatsSaga() {
  yield takeEvery(getSupplierStatsStart.type, getSupplierStatsSaga);
}
